var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51112 16.5261C12.1959 21.6975 16.4846 25.9 21.76 28.5311L25.8504 24.5097C26.3633 24.0064 27.0944 23.863 27.7375 24.0635C29.8144 24.7373 32.0552 25.1031 34.3687 25.1031C35.3999 25.1031 36.2275 25.915 36.2275 26.9268V33.3089C36.2275 34.3207 35.3999 35.1326 34.3687 35.1326C16.9156 35.1326 2.77271 21.2574 2.77271 4.13278C2.77271 3.12629 3.60563 2.30908 4.63147 2.30908H11.1364C12.1676 2.30908 12.9952 3.12103 12.9952 4.13278C12.9952 6.40264 13.368 8.60189 14.0547 10.6427C14.2591 11.2698 14.1129 11.9924 13.6 12.4957L9.51112 16.5269V16.5261Z",
    fill: "#B8963A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.cae4199699f26c6cd413f41d5f41740d.svg";
export { ForwardRef as ReactComponent };